import { useState } from 'react';
import { SideImage } from '../../components/SideImage';
import { RoomUpgradeDialog } from '../../composites/RoomUpgradeDialog';
import { RoomUpgradeOfferPanel } from '../../composites/RoomUpgradeOfferPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { RoomUpgradeTemplateProps } from './RoomUpgradeTemplate.types';

export function RoomUpgradeTemplate({
  originalRoom,
  upgradeRoom,
  locale,
  onSkip,
  onUpgrade,
  onBack,
  labels = {},
}: RoomUpgradeTemplateProps) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const {
    title,
    titleAccent,
    backAriaLabel,
    seeDetails,
    upgradeFor,
    forStay,
    perNight,
    totalDue,
    skip,
    upgrade,
    close,
    noImage,
    previousImage,
    nextImage,
    goToImage,
  } = labels;

  return (
    <>
      <SplitLayout
        leftWidth="45%"
        hideLeftOnMobile
        left={
          <SideImage
            src={originalRoom?.imageUrl ?? undefined}
            alt={originalRoom?.name ?? ''}
            sticky
          />
        }
        right={
          <RoomUpgradeOfferPanel
            upgradeRoom={upgradeRoom}
            locale={locale}
            onShowDetails={() => setDetailsOpen(true)}
            onSkip={onSkip}
            onUpgrade={onUpgrade}
            onBack={onBack}
            labels={{
              title,
              titleAccent,
              seeDetails,
              upgradeFor,
              forStay,
              perNight,
              skip,
              upgrade,
              noImage,
              backAriaLabel,
            }}
          />
        }
      />
      <RoomUpgradeDialog
        open={detailsOpen}
        upgradeRoom={upgradeRoom}
        locale={locale}
        onClose={() => setDetailsOpen(false)}
        onSkip={onSkip}
        onUpgrade={onUpgrade}
        labels={{
          perNight,
          totalDue,
          skip,
          upgrade,
          close,
          previousImage,
          nextImage,
          goToImage,
        }}
      />
    </>
  );
}
